export default __webpack_public_path__ + "static/media/t3-p1-img1.cee6eca5.png";